import React from 'react';
import LegalPage from '../components/LegalPage';

const sections = [
    {
        title: 'Drepturile',
        items: [
            'Să primiți îngrijiri medicale de calitate, fără nicio discriminare.',
            'Să fiți informat despre serviciile clinicii, despre identitatea și calificarea medicilor care vă tratează și despre regulile de funcționare.',
            'Să fiți informat despre starea de sănătate, despre intervențiile propuse, cu riscurile, beneficiile și alternativele lor, și despre ce se întâmplă dacă nu urmați tratamentul — într-un limbaj pe care îl înțelegeți.',
            'Să cereți să nu fiți informat, sau să alegeți persoana care să fie informată în locul dumneavoastră.',
            'Să acceptați sau să refuzați un act medical, după ce vi s-au explicat consecințele.',
            'Să vă fie păstrate confidențiale toate informațiile despre starea de sănătate, chiar și după deces.',
            'Să aveți acces la datele medicale și să primiți copii ale documentelor din dosar.',
            'Să cereți o a doua opinie medicală.',
            'Să faceți o reclamație și să primiți un răspuns.'
        ]
    },
    {
        title: 'Obligațiile',
        items: [
            'Să dați informații corecte despre starea de sănătate, despre bolile anterioare și despre medicamentele pe care le luați.',
            'Să respectați programările sau să le anulați din timp.',
            'Să respectați personalul, ceilalți pacienți și regulile clinicii.',
            'Să plătiți serviciile primite, la prețurile comunicate.'
        ]
    },
    {
        title: 'Temeiul',
        unnumbered: true,
        text: 'Legea nr. 46/2003 a drepturilor pacientului și normele de aplicare aprobate prin Ordinul ministrului sănătății nr. 1.410/2016.'
    }
];

function DrepturilePacientului() {
    return (
        <LegalPage
            eyebrow="Informații legale"
            title="Drepturile și obligațiile pacientului"
            intro="Le rezumăm aici, pe înțelesul tuturor, după Legea nr. 46/2003 a drepturilor pacientului. Textul integral al legii se poate consulta la recepție."
            sections={sections}
            footnote="EVOO-COM-MAN-01-R3 · versiunea din 25.10.2026"
        />
    );
}

export default DrepturilePacientului;
